import { lazy, Suspense } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import AppLoader from '../AppLoader';
import Secure from 'components/Secure';

const Branding = lazy(() => import('components/pages/Branding'));
const CashOffice = lazy(() => import('components/pages/CashOffice'));
const Catalog = lazy(() => import('components/pages/Catalog'));
const Dashboard = lazy(() => import('components/pages/Dashboard'));
const Operations = lazy(() => import('components/pages/Operations'));
const Organization = lazy(() => import('components/pages/Organization'));
const Sales = lazy(() => import('components/pages/Sales'));
const Utilities = lazy(() => import('components/pages/Utilities'));

function PrivateContent() {
  return (
    <>
      <Suspense fallback={<AppLoader />}>
        <Switch>
          <Secure path="/dashboard" component={Dashboard} />
          <Secure path="/branding" component={Branding} />
          <Secure path="/cash-office" component={CashOffice} />
          <Secure path="/catalog" component={Catalog} />
          <Secure path="/operations" component={Operations} />
          <Secure path="/organization" component={Organization} />
          <Secure path="/sales" component={Sales} />
          <Secure path="/utilities" component={Utilities} />
          <Redirect to="/dashboard" />
        </Switch>
      </Suspense>
    </>
  );
}

export default PrivateContent;
